var map = {
	"./approval_top_up.svg": "e0d4",
	"./area_cakupan.svg": "b3d8",
	"./area_keterlambatan.svg": "5ab6",
	"./automasi_indikasi_dex_palsu.svg": "d7b9",
	"./bagging_grouping.svg": "380b",
	"./base_rate.svg": "6bcf",
	"./beranda.svg": "d518",
	"./booking-cargo.svg": "de932",
	"./booking.svg": "40a9f",
	"./booking_aplikasi_&_marketplace.svg": "b405",
	"./booking_bulk.svg": "211f",
	"./booking_korporat.svg": "3bd4",
	"./booking_retail.svg": "d82a",
	"./bulk_booking.svg": "e18a",
	"./cari_stt.svg": "228e",
	"./cek_tarif.svg": "3f6a",
	"./cetak_resi.svg": "e892",
	"./cetak_tagihan.svg": "c950",
	"./cn_manifest.svg": "a2cf",
	"./daftar-cargo.svg": "533f",
	"./daftar_booking.svg": "d20b",
	"./daftar_dex_asesmen.svg": "5a3f",
	"./daftar_pesanan_customer.svg": "bf30",
	"./daftar_pesanan_merchant.svg": "1c0a",
	"./daftar_pick_up.svg": "12f2",
	"./delivery.svg": "0351",
	"./delivery_manifest.svg": "87a5",
	"./dex.svg": "2d9b",
	"./dex_asesmen.svg": "cc01",
	"./dex_l1.svg": "b21a",
	"./dex_l2.svg": "c4e4",
	"./dokumen_internasional.svg": "a08b",
	"./embargo.svg": "1926",
	"./handover_vendor_(hnd).svg": "50f8",
	"./incoming_&_outgoing.svg": "eeaa",
	"./integrasi_api.svg": "48d1",
	"./jenis_pengiriman.svg": "fba0",
	"./kiriman_penting.svg": "9c17",
	"./klaim.svg": "ff00",
	"./komoditas.svg": "890e",
	"./konfigurasi_banner.svg": "305e",
	"./konfigurasi_batas_saldo.svg": "202f",
	"./konfigurasi_cod.svg": "b788",
	"./konfigurasi_cs.svg": "548a",
	"./konfigurasi_denda_saldo_minus.svg": "2845",
	"./konfigurasi_harga.svg": "bb8a",
	"./konfigurasi_jadwal_pickup.svg": "6e3f",
	"./konfigurasi_kargo.svg": "d102",
	"./konfigurasi_komisi.svg": "6399",
	"./konfigurasi_konten.svg": "ec81",
	"./konfigurasi_master_data.svg": "3441",
	"./konfigurasi_network.svg": "989f",
	"./konfigurasi_pesan.svg": "ff18",
	"./konfigurasi_tarif.svg": "3da0",
	"./konfigurasi_top_up_&_cashback.svg": "46c6",
	"./konversi_mata_uang.svg": "04db",
	"./kuota_tiket_cs.svg": "aa81",
	"./lacak_pengiriman.svg": "3125",
	"./lainnya.svg": "1a5e",
	"./laporan.svg": "0353",
	"./list_kargo.svg": "7631",
	"./manage_area.svg": "0bef4",
	"./manajemen_data.svg": "1512",
	"./manajemen_keuangan.svg": "e114",
	"./manajemen_korporat.svg": "2e9c",
	"./manajemen_kurir.svg": "54ab",
	"./manajemen_log.svg": "766b",
	"./manajemen_login_&_perangkat.svg": "0961",
	"./manajemen_moda.svg": "4ddc",
	"./manajemen_partner.svg": "298a",
	"./manajemen_pelanggan.svg": "8260",
	"./manajemen_pos_cabang_&di-pickup.svg": "c53a",
	"./manajemen_rute.svg": "4ee2",
	"./manajemen_user.svg": "24b6",
	"./manajemen_vendor.svg": "7563",
	"./manual_stt.svg": "3d9f",
	"./manual_transaksi.svg": "a61e",
	"./masukan_&_saran.svg": "dc62",
	"./middleware.svg": "1053",
	"./monitor_integrasi_api.svg": "f4ef",
	"./monitoring.svg": "f2d97",
	"./outline_lacak.svg": "dbc7",
	"./pajak_barang.svg": "f6e5",
	"./pengumuman.svg": "ad043",
	"./performa_dex_asesmen.svg": "6026",
	"./pesanan_kulioner.svg": "3fd8",
	"./pick_up.svg": "3daf",
	"./pickup_dashboard.svg": "8270",
	"./pickup_dashboard_monitoring.svg": "6c3b",
	"./pod_dex.svg": "990f",
	"./promo_diskon.svg": "963a",
	"./proses_bag.svg": "7871",
	"./proses_custom_status.svg": "a67e",
	"./proses_dispatch.svg": "7bad",
	"./proses_kargo.svg": "53b7",
	"./proses_pup.svg": "e33c",
	"./proses_rtc.svg": "fab6",
	"./proses_sti.svg": "37f8c",
	"./proses_sti_sc.svg": "9d70",
	"./proses_stidest.svg": "6592",
	"./proses_stidest_sc.svg": "7dc2",
	"./proses_sto_sc.svg": "4015",
	"./pusat_panduan.svg": "8bfb",
	"./rekon_delivery.svg": "30c3",
	"./request_hal.svg": "3f33",
	"./rp.svg": "93c2",
	"./saldo_terakhir.svg": "d131",
	"./stt_dalam_proses.svg": "abfc",
	"./stt_kurang_bayar.svg": "c03a",
	"./stt_shortland.svg": "3fa7",
	"./tarif_komoditas.svg": "89e5",
	"./tax.svg": "db37",
	"./transaksi_saldo_nett.svg": "a66b",
	"./transfer_hub_(in_out_hub).svg": "423c",
	"./unduh_format_&_data.svg": "d86a",
	"./unggah_dan_unduh_data.svg": "820b",
	"./unggah_data.svg": "dc07",
	"./vector.svg": "ce68",
	"./verifikasi_top_up.svg": "be02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4c715";